export default __webpack_public_path__ + "static/media/RVM.73103b51.mp4";